/**
 * Talk to a YouTube embed over the IFrame API's postMessage channel.
 *
 * `enablejsapi=1` on the src (see withYtParams in CourseViews.jsx) opens the
 * channel: commands go in as {event:"command", func, args}, and after a
 * {event:"listening"} handshake YouTube answers with a stream of `infoDelivery`
 * messages carrying playerState, currentTime and the rest. No SDK download, and
 * it is the same channel videoTime.js already speaks for note timestamps.
 *
 * This is what YouTubeGuard's click shields ride on: a click on a shielded zone
 * plays or pauses the video instead of opening youtube.com.
 *
 * A fuller transport used to live here — it drove VideoChrome over this same
 * channel so a YouTube lesson could wear our own control bar with YouTube's UI
 * switched off (controls=0). That bar could not offer video QUALITY, which only
 * YouTube's settings gear can set (the API accepts setPlaybackQuality and then
 * ignores it), and had no playback-speed or captions menu of YouTube's either.
 * A lesson now keeps YouTube's controls and shields the branding around them, so
 * the transport went with the bar; `git log -- src/youtubeTransport.js` has it.
 */

/** Post a player command into the embed. Silent when the frame is not ready. */
export function ytCommand(frame, func, args = []) {
    try {
        frame?.contentWindow?.postMessage(JSON.stringify({ event: "command", func, args }), "*");
    } catch { /* ignore */ }
}
